module.exports = __webpack_public_path__ + "img/CAT_CHEMICAL_REAGENT.87405eec.svg";